import { InboxSearchOptions } from './InboxSearchContext'

const NOTIFICATION_TYPE_KEYS = [
  'billing',
  'comments',
  'replies',
  'mentions',
  'downloadableAssets',
  'starredUpdates',
] as const

type NotificationTypeKey = (typeof NOTIFICATION_TYPE_KEYS)[number]

const convertToUTC = (dateString: string): string => {
  const date = new Date(dateString)
  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds()
  ).toISOString()
}

const collapseSpaces = (s: string) => s.replace(/\s+/g, ' ').trim()

export const buildSearchString = ({
  search,
  options,
}: {
  search: string
  options: InboxSearchOptions
}) => {
  const tokens: string[] = []

  if (search.trim()) tokens.push(search.trim())

  NOTIFICATION_TYPE_KEYS.forEach((key: NotificationTypeKey) => {
    if (options[key]) tokens.push(`type:${key}`)
  })

  if (options.location) {
    tokens.push(`${options.location.type}:${options.location.identifier}`)
  }

  if (options.workspace) {
    tokens.push(`workspace:${options.workspace}`)
  }

  if (options.from) tokens.push(`from:${convertToUTC(options.from)}`)
  if (options.to) tokens.push(`to:${convertToUTC(options.to)}`)

  return collapseSpaces(tokens.join(' '))
}
